import { render } from "./InsuranceCompanies.vue?vue&type=template&id=7b609cd8&scoped=true"
import script from "./InsuranceCompanies.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanies.vue?vue&type=script&lang=js"

import "./InsuranceCompanies.vue?vue&type=style&index=0&id=7b609cd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b609cd8"]])

export default __exports__